/** Mirrors landing gold gradient + src/theme/palette.js for JS inline styles & PDF export */
export const PT = {
  primary: '#FBBD23',
  primaryDark: '#F49715',
  primaryLight: '#FCCF4A',
  primaryGradient: 'linear-gradient(108.59deg, #FBBD23 0%, #F49715 100%)',
  secondary: '#011B36',
  secondaryDark: '#011429',
  landingBg: '#0A1331',
  info: '#1861FF',
  infoLight: '#5289FF',
  success: '#53C483',
  successMain: '#01AD2C',
  warning: '#FFC107',
  error: '#FF5656',
  errorMain: '#FF1E1E',
  white: '#FFFFFF',
  black: '#040404',
  grey100: '#F9FAFB',
  grey500: '#919EAB',
  grey600: '#637381',
  grey700: '#454F5B',
}

export const SECTION_COLORS = {
  atl: PT.info,
  btl: PT.infoLight,
  post: PT.success,
  other: PT.warning,
}
